import config from "../../config"
import RequestService from "../RequestService"

const fetchLaborTypes = (successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/labor_types`, successCallback, failureCallback)
}

export default fetchLaborTypes;